import React, { Component } from "react";
import axios from "axios";
import Ambassadrices from "./Components/Ambassadrices";
import MapAmbassadrice from "./Components/MapAmbassadrice";
import AmbassadriceContent from "./Components/AmbassadriceContent";
import ReactDOM from "react-dom";
import AtelierDetail from "./Components/AtelierDetail";
import moment from "moment";

const apiUrl = "https://www.monmomentmagique.com/wp-json/wp/v2/users";
/* axios.defaults.headers.common["Authorization"] =
  "Basic amVyb21lYjpxdWFpMTMwMTY="; */

const urlString = document.location.href;
const url = new URL(urlString);
const startAmbassadrice = url.searchParams.get("id");

class AppAmbassadrice extends Component {
  static defaultProps = {
    startAmbassadrice: startAmbassadrice ? startAmbassadrice : 467,
    //startAmbassadrice: startAmbassadrice ? startAmbassadrice : "amba2"
  };

  state = {
    ambassadrices: [],
    filteredAmbassadrices: [],
    input: "",
    displayMap: startAmbassadrice ? false : true,
    currentAmbassadrice: this.props.startAmbassadrice,
    currentAmbassadriceData: [],
    currentAtlList: [],
    displayHover: false,
  };

  componentDidMount() {
    this.getAllAmbassadrices();
    this.getCurrentAmbassadriceData();
    this.getCurrentAtlList();
    this.getCategories();
  }

  componentDidUpdate(previousProps, previousState) {
    if (previousState.currentAmbassadrice !== this.state.currentAmbassadrice) {
      this.getCurrentAmbassadriceData();
    }
    if (previousState.input !== this.state.input) {
      this.updateAmbassadrices();
    }
    if (previousState.currentAmbassadrice !== this.state.currentAmbassadrice) {
      this.getCurrentAtlList();
    }
  }

  getAllAmbassadrices = () => {
    axios.get(apiUrl + "?exclude=1,3,6,31&per_page=400").then((res) => {
      const users = res.data;
      const ambassadrices = users; /* .filter(u => u.acf.length !== 0) */
      this.setState({
        ambassadrices,
        filteredAmbassadrices: ambassadrices,
      });
    });
  };

  getCurrentAmbassadriceData = () => {
    axios
      .get(apiUrl + "?include=" + this.state.currentAmbassadrice)
      //.get(apiUrl + "?search=" + this.state.currentAmbassadrice)
      .then((res) => {
        const currentAmbassadriceData = res.data;
        this.setState({
          currentAmbassadriceData,
        });
      });
  };

  getCurrentAtlList = () => {
    axios
      .get(
        "https://www.monmomentmagique.com/wp-json/wp/v2/ateliers" +
          "?_embed&author=" +
          this.state.currentAmbassadrice +
          "&per_page=200"
        // this.state.ambassadrices
        //   .filter(amb => amb.slug === this.props.startAmbassadrice)
        //   .map(amb => amb.id)
      )
      .then((res) => {
        const currentAtlList = res.data;
        currentAtlList.sort(function compare(a, b) {
          var dateA = new moment(a.acf.ateliers_date, "M-D-YYYY");
          var dateB = new moment(b.acf.ateliers_date, "M-D-YYYY");
          return dateA - dateB;
        });
        this.setState({
          currentAtlList,
        });
      });
  };

  showContent = (id) => {
    this.setState({
      currentAmbassadrice: id,
      displayMap: false,
    });
  };

  showMap = () => {
    this.setState({ displayMap: true });
  };

  updateAmbassadrices = () => {
    if (this.state.input === "") {
      this.setState({ filteredAmbassadrices: this.state.ambassadrices });
    } else {
      /* const filteredAmbassadrices = this.state.ambassadrices.filter(
        a =>
          a.acf.ambassadrice_ville &&
          a.acf.ambassadrice_ville
            .toLowerCase()
            .search(this.state.input.toLowerCase()) !== -1
      ); */
      const filteredAmbassadrices = this.state.ambassadrices.filter(
        (a) =>
          a.acf.ambassadrice_code_postal &&
          a.acf.ambassadrice_code_postal === this.state.input
      );
      this.setState({ filteredAmbassadrices });
    }
  };

  handleSearch = (e) => {
    this.setState({ input: e.target.value });
  };

  displayMarkerInfo = (id) => {
    this.setState({
      currentAmbassadrice: id,
      displayMap: false,
    });
  };

  handleMouseEnter = (id) => {
    this.setState({
      hoveredAmbassadrice: id,
      displayHover: true,
    });
  };
  handleMouseLeave = () => {
    this.setState({
      hoveredAmbassadrice: undefined,
      displayHover: false,
    });
  };

  fillModal = (detail) => {
    ReactDOM.render(
      <AtelierDetail
        data={detail}
        categories={this.state.categories}
        emailModal={this.emailModal}
      />,
      document.getElementById("detail-atelier")
    );
  };

  getCategories = () => {
    axios
      .get("https://www.monmomentmagique.com/wp-json/wp/v2/categories?parent=6")
      .then((res) => {
        const categories = res.data;
        this.setState({ categories });
      });
  };

  emailModal = (email, info) => {
    const elem = document.getElementById("input_4_15");
    // elem.value = info;
    elem.setAttribute("value", info);
    // const elem2 = document.querySelector(".champ-email-ambassadrice input");
    const elem2 = document.getElementById("input_4_16");
    // elem2.value = email;
    elem2.setAttribute("value", email);
  };

  render() {
    return (
      <div className="  page-sidebar-content page-ambassadrice">
        <main id="main" className="site-main">
          <Ambassadrices
            ambassadrices={this.state.filteredAmbassadrices}
            showContent={this.showContent}
            showMap={this.showMap}
            input={this.state.input}
            handleSearch={this.handleSearch}
            handleMouseEnter={this.handleMouseEnter}
            handleMouseLeave={this.handleMouseLeave}
          />
          {this.state.displayMap ? (
            <MapAmbassadrice
              data={this.state.filteredAmbassadrices}
              displayMarkerInfo={this.displayMarkerInfo}
              displayHover={this.state.displayHover}
              hoveredAmbassadrice={this.state.hoveredAmbassadrice}
            />
          ) : (
            <AmbassadriceContent
              showMap={this.showMap}
              data={this.state.currentAmbassadriceData[0]}
              atlList={this.state.currentAtlList}
              fillModal={this.fillModal}
              categories={this.state.categories}
              emailModal={this.emailModal}
            />
          )}
        </main>
      </div>
    );
  }
}

export default AppAmbassadrice;



// WEBPACK FOOTER //
// ./src/AppAmbassadrice.js